const IconNotes = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 512 512"
      fill={props.fill}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <g>
            <path d="M106.667,170.667h106.667c11.782,0,21.333-9.551,21.333-21.333c0-11.782-9.551-21.333-21.333-21.333H106.667c-11.782,0-21.333,9.551-21.333,21.333C85.333,161.115,94.885,170.667,106.667,170.667z" />
            <path d="M234.667,341.333c11.782,0,21.333-9.551,21.333-21.333s-9.551-21.333-21.333-21.333h-128c-11.782,0-21.333,9.551-21.333,21.333s9.551,21.333,21.333,21.333H234.667z" />
            <path d="M106.667,256h64c11.782,0,21.333-9.551,21.333-21.333c0-11.782-9.551-21.333-21.333-21.333h-64c-11.782,0-21.333,9.551-21.333,21.333C85.333,246.449,94.885,256,106.667,256z" />
            <path d="M277.333,170.667H320c11.782,0,21.333-9.551,21.333-21.333c0-11.782-9.551-21.333-21.333-21.333h-42.667C265.551,128,256,137.551,256,149.333C256,161.115,265.551,170.667,277.333,170.667z" />
            <path d="M320,298.667h-21.333c-11.782,0-21.333,9.551-21.333,21.333s9.551,21.333,21.333,21.333H320c11.782,0,21.333-9.551,21.333-21.333S331.782,298.667,320,298.667z" />
            <path d="M213.333,234.667c0,11.782,9.551,21.333,21.333,21.333H320c11.782,0,21.333-9.551,21.333-21.333c0-11.782-9.551-21.333-21.333-21.333h-85.333C222.885,213.333,213.333,222.885,213.333,234.667z" />
            <path d="M490.667,128h-64V64c0-11.782-9.551-21.333-21.333-21.333H234.667V21.333C234.667,9.551,225.115,0,213.333,0C201.551,0,192,9.551,192,21.333v21.333H21.333C9.551,42.667,0,52.218,0,64v341.333c0,11.782,9.551,21.333,21.333,21.333h64v64c0,11.782,9.551,21.333,21.333,21.333h384c11.782,0,21.333-9.551,21.333-21.333V149.333C512,137.551,502.449,128,490.667,128z M42.667,85.333H192c0,11.782,9.551,21.333,21.333,21.333c11.782,0,21.333-9.551,21.333-21.333H384v64V384H106.667h-64V85.333z M469.333,469.333H128v-42.667h277.333c11.782,0,21.333-9.551,21.333-21.333V170.667h42.667V469.333z" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default IconNotes
